import {
  INFO_BACKGROUND,
  INFO_COLOR,
  SUCCESS_BACKGROUND,
  SUCCESS_COLOR,
  WARNING_BACKGROUND,
  WARNING_COLOR
} from "../../../../themes/themeConfigurator";


const styles = () => ({
  totalValueChip: {
    background: 'rgba(131, 138, 147, 0.12)',
    borderRadius: 8,
    padding: '10px 12px',
    fontFamily: 'Roboto-Bold',
    fontSize: 24,
    height: 54,
    width: '100%',

    '&.green': {
      color: SUCCESS_COLOR,
      background: SUCCESS_BACKGROUND,
    },
    '&.orange': {
      color: WARNING_COLOR,
      background: WARNING_BACKGROUND,
    },
    '&.blue': {
      color: INFO_COLOR,
      background: INFO_BACKGROUND,
    }
  }
});

export default styles;